// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-modal .modal-container {
  max-height: 90vh;
  overflow: hidden;
}
.edit-modal .modal-container .modal-subheader {
  font-weight: bold;
  font-size: 16px;
}
.edit-modal .modal-container .modal-header div {
  position: relative;
}
.edit-modal .modal-container .modal-header div h1 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 35px;
}
.edit-modal .modal-container .modal-header div .text-xs-right {
  position: absolute;
  right: -5px;
  top: -10px;
}
.edit-modal .modal-container .modal-header div .text-xs-right .close-icon {
  cursor: pointer;
}
.edit-modal .row-edit-modal .columnTitle {
  padding-top: 20px;
  height: 50px;
  text-align: right;
  font-weight: 700;
}
.edit-modal .row-edit-modal .columnValue .rowValueInput {
  height: 40px;
  border: 1px solid darkgray;
  border-radius: var(--text-input-border-radius);
  padding: 5px;
  width: 500px;
  margin: 10px 0;
}
.edit-modal .row-edit-modal .columnValue .v-alert {
  font-size: 14px;
  padding: 10px;
  width: 500px;
  margin-left: 10px;
}
.edit-modal .row-edit-modal .columnValue .v-alert .v-icon {
  font-size: 18px;
}
.edit-modal .row-edit-modal .buildingContainer {
  display: flex;
  margin-top: 5px;
  align-items: center;
}
.edit-modal .row-edit-modal .buildingContainer .buildingSelectButton {
  margin: 5px;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  min-width: 198px !important;
  max-width: 100%;
  letter-spacing: unset;
  color: #FFFFFF;
  text-transform: none;
  border-radius: 6px;
  box-shadow: none;
}
.edit-modal .row-edit-modal .modal-body {
  max-height: 425px;
  overflow-y: auto;
}
.edit-modal .row-edit-modal .modal-footer button {
  margin: 0 10px;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/editModal/src/editModal.vue","webpack://./editModal.vue"],"names":[],"mappings":"AAEE;EACE,gBAAA;EACA,gBAAA;ACDJ;ADGI;EACE,iBAAA;EACA,eAAA;ACDN;ADII;EACE,kBAAA;ACFN;ADGM;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;ACDR;ADGM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;ACDR;ADGQ;EACE,eAAA;ACDV;ADOI;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ACLN;ADQM;EACE,YAAA;EACA,0BAAA;EACA,8CAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;ACNR;ADSM;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;ACPR;ADQQ;EACE,eAAA;ACNV;ADUI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;ACRN;ADUM;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;ACRR;ADWI;EACE,iBAAA;EACA,gBAAA;ACTN;ADYM;EACE,cAAA;ACVR","sourcesContent":["\n.edit-modal {\n  .modal-container {\n    max-height: 90vh;\n    overflow: hidden;\n\n    .modal-subheader {\n      font-weight: bold;\n      font-size: 16px;;\n    }\n\n    .modal-header div {\n      position: relative;\n      h1 {\n        margin: 0;\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 35px;\n      }\n      .text-xs-right {\n        position: absolute;\n        right: -5px;\n        top: -10px;\n\n        .close-icon {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .row-edit-modal {\n    .columnTitle {\n      padding-top: 20px;\n      height: 50px;\n      text-align: right;\n      font-weight: 700;\n    }\n    .columnValue {\n      .rowValueInput {\n        height: 40px;\n        border: 1px solid darkgray;\n        border-radius: var(--text-input-border-radius);\n        padding: 5px;\n        width: 500px;\n        margin: 10px 0;\n      }\n\n      .v-alert {\n        font-size: 14px;\n        padding: 10px;\n        width: 500px;\n        margin-left: 10px;\n        .v-icon {\n          font-size: 18px;\n        }\n      }\n    }\n    .buildingContainer {\n      display: flex;\n      margin-top: 5px;\n      align-items: center;\n\n      .buildingSelectButton {\n        margin: 5px;\n        font-size: 14px;\n        font-weight: 600;\n        height: 40px;\n        min-width: 198px!important;\n        max-width: 100%;\n        letter-spacing: unset;\n        color: #FFFFFF;\n        text-transform:none;\n        border-radius:6px;\n        box-shadow:none;\n      }\n    }\n    .modal-body {\n      max-height: 425px;\n      overflow-y: auto;\n    }\n    .modal-footer {\n      button {\n        margin: 0 10px;\n      }\n    }\n  }\n}\n",".edit-modal .modal-container {\n  max-height: 90vh;\n  overflow: hidden;\n}\n.edit-modal .modal-container .modal-subheader {\n  font-weight: bold;\n  font-size: 16px;\n}\n.edit-modal .modal-container .modal-header div {\n  position: relative;\n}\n.edit-modal .modal-container .modal-header div h1 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 35px;\n}\n.edit-modal .modal-container .modal-header div .text-xs-right {\n  position: absolute;\n  right: -5px;\n  top: -10px;\n}\n.edit-modal .modal-container .modal-header div .text-xs-right .close-icon {\n  cursor: pointer;\n}\n.edit-modal .row-edit-modal .columnTitle {\n  padding-top: 20px;\n  height: 50px;\n  text-align: right;\n  font-weight: 700;\n}\n.edit-modal .row-edit-modal .columnValue .rowValueInput {\n  height: 40px;\n  border: 1px solid darkgray;\n  border-radius: var(--text-input-border-radius);\n  padding: 5px;\n  width: 500px;\n  margin: 10px 0;\n}\n.edit-modal .row-edit-modal .columnValue .v-alert {\n  font-size: 14px;\n  padding: 10px;\n  width: 500px;\n  margin-left: 10px;\n}\n.edit-modal .row-edit-modal .columnValue .v-alert .v-icon {\n  font-size: 18px;\n}\n.edit-modal .row-edit-modal .buildingContainer {\n  display: flex;\n  margin-top: 5px;\n  align-items: center;\n}\n.edit-modal .row-edit-modal .buildingContainer .buildingSelectButton {\n  margin: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  height: 40px;\n  min-width: 198px !important;\n  max-width: 100%;\n  letter-spacing: unset;\n  color: #FFFFFF;\n  text-transform: none;\n  border-radius: 6px;\n  box-shadow: none;\n}\n.edit-modal .row-edit-modal .modal-body {\n  max-height: 425px;\n  overflow-y: auto;\n}\n.edit-modal .row-edit-modal .modal-footer button {\n  margin: 0 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
